import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../lib/api";
import { LogoMark } from "../components/Logo";
import { Lock, Loader2, ShieldCheck } from "lucide-react";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await adminLogin(form);
      localStorage.setItem("tm_admin_token", data.token);
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-[#153A68] via-[#0C2136] to-[#153A68] px-4">
      <form onSubmit={submit} className="w-full max-w-md rounded-3xl bg-white p-8 sm:p-10 shadow-2xl" data-testid="admin-login-form">
        <div className="flex items-center gap-3">
          <LogoMark size={48} />
          <div>
            <div className="font-display text-2xl font-black tracking-tight text-[#0C2136]">TECHMATE</div>
            <div className="text-[10px] font-bold uppercase tracking-[0.28em] text-primary">Admin Console</div>
          </div>
        </div>
        <div className="mt-6 flex items-center gap-2 text-sm text-muted-foreground">
          <ShieldCheck className="h-4 w-4 text-primary" /> Authorised personnel only
        </div>
        <div className="mt-4 space-y-4">
          <div>
            <label className="text-sm font-semibold text-[#0C2136]">Username</label>
            <input
              data-testid="admin-username-input"
              className="mt-1.5 w-full rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-primary"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              autoComplete="username"
              required
            />
          </div>
          <div>
            <label className="text-sm font-semibold text-[#0C2136]">Password</label>
            <input
              data-testid="admin-password-input"
              type="password"
              className="mt-1.5 w-full rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-primary"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              autoComplete="current-password"
              required
            />
          </div>
        </div>
        {error && (
          <div data-testid="admin-login-error" className="mt-4 rounded-xl bg-red-50 border border-red-200 px-4 py-2.5 text-sm text-red-700">
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full bg-primary hover:bg-primary/90 text-white font-semibold py-3.5 transition-colors"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : (<><Lock className="h-4 w-4" /> Sign in</>)}
        </button>
      </form>
    </div>
  );
}
